import React, { useState } from "react";
import axios from "axios";
import { apiUrl } from "../../constants";
import styles from "./DeleteUser.module.css";
import Button from "../button/Button";
import FunctionalButton from "../button/FunctionalButton";
import OnChangeInputfield from "../onChangeInputField/OnChangeInputField";

const DeleteUser = () => {
  const [email, setEmail] = useState("");
  const [firstDeleteButton, toggleFirstDeleteButton] = useState(true);
  const [finalDeleteButton, toggleFinalDeleteButton] = useState(false);
  const [success, toggleSuccess] = useState(false);
  const [displayForm, toggleDisplayForm] = useState(true);
  const [error, toggleError] = useState(false);
  const [displayError, setDisplayError] = useState("");

  // Here we check first if there is user input (email). If the input is an empty string an error is shown.
  // If there is user input (an email) we show a new delete button to delete the user from the database. Also the email is once more shown before deleting it.
  function deleteUser() {
    if (email === "") {
      toggleError(true);
      setDisplayError("No email.");
    } else {
      toggleError(false);
      toggleFirstDeleteButton(false);
      toggleFinalDeleteButton(true);
    }
  }

  // This function will delete the user from the database and show a success message.
  // If the email doesn't exist a message will be shown and we return to the first step again by
  // toggling the buttons so we can insert an email address again.
  async function deleteUserFinal(e) {
    e.preventDefault();

    const jwtToken = localStorage.getItem("token");

    try {
      const result = await axios.delete(`${apiUrl}/auth/user/${email}`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      toggleDisplayForm(false);
      toggleSuccess(true);
    } catch (e) {
      console.error(e);
      toggleError(true);
      setDisplayError(e.response.data.message);
      toggleFirstDeleteButton(true);
      toggleFinalDeleteButton(false);
      setEmail("");
      document.getElementById("input").value = "";
    }
  }

  return (
    <div className={styles["delete-user-form-wrapper"]}>
      {displayForm && (
        <form onSubmit={deleteUserFinal} className={styles["delete-user-form"]}>
          <h4>Delete user</h4>
          <article className={styles.wrapper}>
            <OnChangeInputfield
              label="Email"
              name="email"
              type="email"
              id="input"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <div className={styles["delete-user-error-wrapper"]}>
              {error && (
                <p className={styles.error}>{displayError} Please try again.</p>
              )}
            </div>
          </article>

          <div className={styles.wrapper}>
            {finalDeleteButton && (
              <div className={styles["final-delete-wrapper"]}>
                <p>Are you sure to delete the user with email: {email} ?</p>
                <section className={styles["delete-user-button-wrapper"]}>
                  <Button type="submit">Yes, delete</Button>
                </section>
              </div>
            )}
          </div>
          {firstDeleteButton && (
            <section className={styles["delete-user-button-wrapper"]}>
              <FunctionalButton type="button" handleClick={deleteUser}>
                Delete user
              </FunctionalButton>
            </section>
          )}
        </form>
      )}

      {success && (
        <p>The user with email: {email} is deleted from the database.</p>
      )}
    </div>
  );
};

export default DeleteUser;
